// hooks/useAuthSync.ts
import { useEffect } from "react";
import { useAuthStore } from "../../store/useAuthStore";
import { useCheckoutFlowStore } from "../../store/useCheckoutFlowStore";

/**
 * Hook to automatically sync authenticated user data with checkout flow
 * This should be used in your main App component or layout
 */
export const useAuthSync = () => {
  const { user, isAuthenticated } = useAuthStore();
  const { syncUserData, clearUserData, lastSyncedUserId } =
    useCheckoutFlowStore();

  useEffect(() => {
    if (isAuthenticated && user) {
      // Sync user data to checkout flow
      syncUserData(user);
    } else {
      // Clear checkout data when user logs out
      clearUserData();
    }
  }, [isAuthenticated, user, syncUserData, clearUserData]);

  // Also sync when user changes (different user logs in)
  useEffect(() => {
    if (user && user.cusId !== lastSyncedUserId) {
      syncUserData(user);
    }
  }, [user, lastSyncedUserId, syncUserData]);
};

export default useAuthSync;
